// apps/web/src/pages/Dashboard.tsx
import { useAuthStore } from "@/store/authStore";
import { trpc } from "@/trpc/client";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";

const DashboardPage = () => {
    const { user } = useAuthStore();
    // Fetch fresh profile to ensure role is up to date before redirecting
    // We trust this over the local store for navigation decisions
    const { data: freshProfile, isLoading } = trpc.user.getProfile.useQuery(undefined, {
        staleTime: 1000 * 30,
    });

    const activeUser = freshProfile || user;

    if (isLoading && !activeUser) {
        return <div className="w-full h-screen flex items-center justify-center"><Loader2 className="w-8 h-8 animate-spin" /></div>;
    }

    if (!activeUser) return <Navigate to="/login" replace />;

    // Redirect based on the user's role
    if (activeUser.role === 'TRANSPORTER') {
        return <Navigate to="/dashboard/transporter" replace />;
    }
    if (activeUser.role === 'FLEET_MANAGER') {
        return <Navigate to="/dashboard/fleet" replace />;
    }
    if (activeUser.role === 'FLEET_DRIVER') {
        return <Navigate to="/dashboard/driver" replace />;
    }
    return <Navigate to="/dashboard/client" replace />;
}
export default DashboardPage;